import { cloneDeep } from 'lodash';
import { ModelType } from '@/enums/model-type.enum';
import { flattenMenuData } from '@/state/nodes/nodes.utils';
import type { Node } from '@/types/node';
import type { AiModelData, Model } from '@/types/nodes/model';
import type { MenuData } from '@/state/nodes/nodes.types';

/** Maps an AI model service to the icon key used in template/node-definition entries. */
export function getModelServiceIconKey(service: string): string {
  switch (service) {
    case ModelType.FalImported:
      return 'fal';
    case ModelType.Replicate:
      return 'replicate';
    case ModelType.Civit:
      return 'civit';
    default:
      return 'weavy';
  }
}

/**
 * For saving we get the icon either from origin menu node or if imported take service icon
 */
export function resolveSavedModelIconKey(model: Partial<Model> | undefined, menu: Partial<MenuData>): string {
  const menuIcon = model?.name ? flattenMenuData(menu).find((m) => m.name === model.name)?.icon : undefined;
  return menuIcon ?? getModelServiceIconKey(model?.service ?? '');
}

// TODO: Check if imported → user_defined conversion is still needed with subflow templates.
// Legacy behavior from the old /v1/user/node-definitions save path.
export function prepareModelNode(node: Node): Node {
  const clone = cloneDeep(node);
  const data = clone.data as AiModelData;
  if (data.kind?.type === 'wildcard' && data.kind.model.type === 'imported') {
    data.kind = {
      ...data.kind,
      model: { ...data.kind.model, type: 'user_defined' },
    };
  }
  return clone;
}
